import { render, staticRenderFns } from "./Property.html?vue&type=template&id=13cd3e86&"
import script from "./Property.ts?vue&type=script&lang=ts&"
export * from "./Property.ts?vue&type=script&lang=ts&"
import style0 from "@/scss/components/properties/_property.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports